<img src="/static/assets/loader.svg" />
